import React from 'react';
import { Button } from 'react-bootstrap';
import { useFieldStore } from '../../providers/FieldProvider';
import { dcRound } from "../../../../utils/misc";
import { useUnitConversion } from "../../../../utils/unitConversion";

type Props = {
    totalArea: number | null,
    fieldCount: number,
    isFiltered: boolean
}

const FieldListHeader = ({totalArea, fieldCount, isFiltered}: Props) => {
    const { resetFilter } = useFieldStore();
    const { convertToPreferredUnitValue, convertToPreferredUnitString, unitsConvert } = useUnitConversion();
    

    return (
        <div className="align-items-center border-bottom border-top d-flex justify-content-between px-3 py-2">
            <span className="font-weight-bold text-capitalize text-sm font-weight-bold">{`${dcRound(fieldCount, false,[false,0],true)} Blks${totalArea ? ` (${convertToPreferredUnitString(totalArea, 'ac', 'area', 'mid', 'abbr')})` : ""}`}</span>
            {
                isFiltered
                ? <Button style={{width: '40px', lineHeight: "1"}} className="p-0" variant="link" onClick={(e:any) => resetFilter()}>
                    <span style={{fontSize:"10px", lineHeight: "1"}} className="text-xs">remove filters</span>
                </Button>
                : ''
            }
        </div>
    );
}

export default FieldListHeader;